module.exports = __webpack_public_path__ + "img/img7.87ddbe0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/04/img7.png
// module id = 238
// module chunks = 0